import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Widget from '../Widget';
import WidgetTable from './Shared/WidgetTable';

export default class UpcomingEventsWidget extends Component {
  static propTypes = {
    seeMoreUrl: PropTypes.string.isRequired,
    useTimezone: PropTypes.string,
  }

  static defaultProps = {
    useTimezone: moment.tz.guess(),
  }

  // Render Main screen using the data from `run_query`

  renderMainScreen(data) {
    return (
      <WidgetTable
        headerRow={
          <tr>
            <th className="u-w-80">EVENT TITLE</th>
            <th>DATE</th>
            <th>RSVPs</th>
          </tr>
        }
        dataRows={data.map(item => this.renderRow(item))}
        seeMoreUrl={this.props.seeMoreUrl} />
    );
  }

  renderRow(item) {
    return (
      <tr key={item.id}>
        <td>{this.renderTitle(item)}</td>
        <td>{this.renderDate(item.start_date)}</td>
        <td>{item.confirmed_slots_stat}</td>
      </tr>
    );
  }

  renderDate(date) {
    return moment(date)
      .tz(this.props.useTimezone)
      .format('MMM D, YYYY');
  }

  renderTitle(item) {
    return (
      <div className="u-w-76 u-truncate">
        <a href={item.staff_path}>
          {item.name}
        </a>
      </div>
    );
  }

  render() {
    return (
      <Widget
        renderMainScreen={this.renderMainScreen.bind(this)}
        {...this.props}
      />
    );
  }
}
